import React from "react";
import { useHistory } from "react-router-dom";
import MuiBox from "@mui/material/Box";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import Box from "components/common/Box";
import NavPill from "components/allInOneDashboard/nav/NavPill";
import { UNIFIED_DASHBOARD_PATH } from "components/allInOneDashboard/constants/productRouteMap";
import {
  NAV_COLORS,
  NAV_TRANSITION,
} from "components/allInOneDashboard/constants/navTheme";

const ProductPageNav = ({
  tabs = [],
  explorePath = UNIFIED_DASHBOARD_PATH,
  onNavigate,
}) => {
  const history = useHistory();

  const handleBackClick = () => {
    history.push(explorePath);
  };

  const handleTabClick = (tab) => {
    if (tab.isDisabled || !tab.path) return;
    if (onNavigate) {
      onNavigate(tab.path);
    } else {
      history.push(tab.path);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2.5,
        py: 1,
        mb: 1,
        minWidth: 0,
      }}
    >
      <Box
        onClick={handleBackClick}
        sx={{
          width: 42,
          height: 42,
          borderRadius: "10px",
          bgcolor: NAV_COLORS.backButtonBg,
          border: `1px solid ${NAV_COLORS.backButtonBorder}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flexShrink: 0,
          transition: `background-color ${NAV_TRANSITION}`,
          "&:hover": { bgcolor: "#F3F4F6" },
        }}
      >
        <ArrowBackOutlinedIcon
          sx={{ fontSize: 24, color: NAV_COLORS.inactiveNav }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          overflowX: "auto",
          overflowY: "hidden",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <MuiBox
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 3,
            flexWrap: "nowrap",
            py: 0.5,
          }}
        >
          {tabs.map((tab) => (
            <NavPill
              key={tab.id}
              label={tab.label}
              active={tab.isActive}
              disabled={tab.isDisabled}
              onClick={() => handleTabClick(tab)}
              labelClassName="product-nav-label"
            />
          ))}
        </MuiBox>
      </Box>
    </Box>
  );
};

export default ProductPageNav;
